import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import { MdSelectAll } from 'react-icons/md';

import { ENTITIES, QuerybuilderResult } from 'src/models/QuerybuilderModel';
import { setSelections } from 'src/redux/actions/selectionActions';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { t } from 'src/lib/language';
import { normalizeForForm } from 'src/lib/QueryBuilderHelper';
import { updatePaymentAction } from 'src/redux/actions/paymentActions';

interface CustomProps {
  entity: ENTITIES,
}

type Props = CustomProps & ButtonProps;

const SelectAllMenubutton = (props: Props) => {
  const { disabled, entity } = props;
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language);
  const { ids, list } = useSelector(
    (state: Store) => state.querybuilder[entity]?.result as QuerybuilderResult
      || {} as QuerybuilderResult,
  );

  const handleOnClick = () => {
    dispatch(setSelections({
      entity,
      selections: [...ids],
    }));
    list.forEach((result) => {
      const payment = (normalizeForForm(result, entity));
      dispatch(updatePaymentAction({ id: payment.id, payment }));
    });
  };

  return (
    <Tooltip
      title={t(lang, 'menus.select_all')}
      placement="top-start">
      <span>
        <ActionButton
          variant="outlined"
          category={MENU_BUTTON_CATEGORY.selection}
          onClick={handleOnClick}
          disabled={disabled}>
          <MdSelectAll style={{ height: '24px', width: '24px' }} />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default SelectAllMenubutton;
